<template>
  <div class="component-grid-clients">
    <ul class="component-grid-clients__grid">
      <li v-for="(client, index) in clients" :key="index">
        <CardClient :client="client" />
      </li>
    </ul>
    <img
      src="@/assets/components/landing/clients-grid/pattern.svg"
      class="component-grid-clients__pattern"
      alt=""
    />
  </div>
</template>

<script>
import CardClient from '@/components/CardClient'
export default {
  name: 'LandingClientsGrid',
  components: { CardClient },
  props: {
    clients: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style lang="scss">
.component-grid-clients {
  position: relative;

  &__grid {
    position: relative;
    z-index: 2;
    margin: rem(-8px);
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: flex-end;
    align-content: stretch;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $white;
      width: calc(20% - 1rem);
      flex: 0 0 calc(20% - 1rem);
      margin: rem(8px);
      @include transition(0.2s);

      @include media-breakpoint-only(md) {
        width: calc(25% - 1rem);
        flex: 0 0 calc(25% - 1rem);
      }

      @include media-breakpoint-down(sm) {
        width: calc(50% - 1rem);
        flex: 0 0 calc(50% - 1rem);
      }

      a {
        padding-bottom: 70%;
        position: relative;
        display: block;
        width: 100%;
        color: $gray-900;
        // padding: rem(60px) rem(40px);
        text-decoration: none;

        @include media-breakpoint-down(lg) {
          padding: rem(50px) rem(30px);
        }

        @include media-breakpoint-down(md) {
          padding: rem(50px) rem(25px);
        }

        img {
          padding: rem(32px);
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          object-position: center center;
          object-fit: contain;

          @media all and (-ms-high-contrast: none),
            (-ms-high-contrast: active) {
            /* IE10+ CSS styles go here */
            top: 50%;
            left: 50%;
            height: auto;
            width: auto;
            max-height: 100%;
            max-width: 100%;
            transform: translate3d(-50%, -50%, 0);
          }
        }
      }

      &:hover,
      &:active,
      &:focus {
        transform: translateY(-1px);
        box-shadow: $box-shadow-light;
      }
    }
  }

  &__pattern {
    position: absolute;
    left: rem(-48px);
    top: rem(44px);
    z-index: 1;

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
}
</style>
